import { ArrowDown, ArrowDownUp, ArrowUp } from 'lucide-react';

import { cn } from '@shared/lib/utils';

import { Button, type ButtonProps } from '../primitives/button';

type SortDirection = 'asc' | 'desc';

type SortableHeaderButtonProps<TSortKey extends string> = {
  label: string;
  sortKey: TSortKey;
  currentSortKey: TSortKey;
  currentSortDirection: SortDirection;
  onToggle: (sortKey: TSortKey) => void;
  className?: string;
  iconClassName?: string;
  buttonSize?: ButtonProps['size'];
  disabled?: boolean;
};

export function SortableHeaderButton<TSortKey extends string>({
  label,
  sortKey,
  currentSortKey,
  currentSortDirection,
  onToggle,
  className,
  iconClassName,
  buttonSize = 'sm',
  disabled = false,
}: SortableHeaderButtonProps<TSortKey>) {
  const isActive = currentSortKey === sortKey;
  const DirectionIcon = !isActive
    ? ArrowDownUp
    : currentSortDirection === 'asc'
      ? ArrowUp
      : ArrowDown;

  return (
    <Button
      type="button"
      variant="ghost"
      size={buttonSize}
      disabled={disabled}
      className={cn(
        'inline-flex h-auto min-w-0 max-w-full items-center justify-start gap-1 whitespace-normal px-0 py-0 text-left text-xs font-normal text-muted-foreground hover:text-foreground',
        className
      )}
      aria-sort={isActive ? (currentSortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}
      onClick={() => {
        onToggle(sortKey);
      }}
    >
      <span className="min-w-0 break-words">{label}</span>
      <DirectionIcon className={cn('h-3 w-3 shrink-0', iconClassName)} aria-hidden="true" />
    </Button>
  );
}
